module.exports = __webpack_public_path__ + "static/media/view4.c67ef63a.jpg";